/**
 * Cross-route flag recording whether the login-time E2EE identity provisioning
 * FAILED (or timed out). Login owns the only moment we have the password, so it
 * provisions there; the class view can't re-provision from a password. This
 * module-level boolean is the pass-through Login uses to tell Class that the
 * identity may not be ready, so Class can surface a non-blocking "encryption not
 * ready" state and offer the plaintext fallback instead of letting a QR scan
 * fail with `noIdentity`.
 *
 * State lives only in memory for the browser session (alongside the in-memory
 * identity in e2eeSession.ts) — it is never persisted.
 */
let provisionFailed = false;

/** Record the outcome of the login-time provisioning attempt. */
export function setProvisionFailed(failed: boolean): void {
  provisionFailed = failed;
}

/** True when the last login-time provisioning attempt failed or timed out. */
export function getProvisionFailed(): boolean {
  return provisionFailed;
}
